import MainPageHeader, { type MainPageHeaderProps } from './MainPageHeader';
import MainPageContainer, { type MainPageContainerProps } from './MainPageContainer';

export type MainPageLayoutProps = MainPageContainerProps & MainPageHeaderProps;

const MainPageLayout = ({ children, title, handleHistoryBack } : MainPageLayoutProps) : JSX.Element => {
  return (
    <MainPageContainer>
      <MainPageHeader title={title} handleHistoryBack={handleHistoryBack} />
      {children}
    </MainPageContainer>
  );
};

export default MainPageLayout;